<section class="asset-management-section">
  <ts-page-header>
    <ng-container page-header-title>
      <p class="flex flex-row gap-2 justify-start items-center font-ts-header-title text-ts-header-title">
        Accounts Mapping<a class="flex flex-row items-center" href="" target="_blank">
          <ts-icon color="gray" icon="ts_question-circle" />
        </a>
      </p>
    </ng-container>
    <ng-container page-header-action-buttons>
      <section class="flex flex-row items-center gap-2">
        <ts-button variant="secondary" icon="ts_file-import" (click)="importAccountMapping.emit()">Import</ts-button>
        <ts-button variant="primary" icon="ts_link" (click)="manageAccountMapping.emit()">Add Mapping</ts-button>
      </section>
    </ng-container>
    <div class="w-full flex flex-row items-center justify-start gap-2" page-header-action-bar>
      <ts-input
        size="sm"
        placeholder="Filter accounts"
        icon="ts_search"
        class="max-w-1/4"
        clearable="true"
        [formControl]="accountsFormFilter"
      ></ts-input>
    </div>
  </ts-page-header>

  <ts-tab-group
    class="h-full w-full"
    [tabs]="[
      { label: 'Mapped Accounts', icon: 'ts_link', template: mappedTabContent },
      { label: unmappedAccountsTabLabel(), icon: 'ts_link-broken', template: unmappedAccountsTabContent },
    ]"
  ></ts-tab-group>
</section>

<ng-template #mappedTabContent>
  <ts-table
    class="h-full"
    [loading]="loading"
    [autoHeight]="false"
    [rowData]="filteredMappedAccounts()"
    [columnDefs]="mappedAccountColumns"
    [actions]="mappedAccountActions"
    [hasActionsColumn]="true"
  ></ts-table>
</ng-template>

<ng-template #unmappedAccountsTabContent>
  <ts-table
    class="h-full"
    [loading]="loading"
    [autoHeight]="false"
    [rowData]="filteredUnmappedAccounts()"
    [columnDefs]="unmappedAccountColumns"
    [actions]="unmappedAccountActions"
    [hasActionsColumn]="true"
  ></ts-table>
</ng-template>
